import React from 'react';
import ThemeCardThemeStatus from './ThemeCardThemeStatus';
import LinkedContainer from './theme-card/LinkedContainer';
import Container from './theme-card/Container';
import ParentName from './theme-card/ParentName'
import ThemeName from './theme-card/ThemeName';
import thronThumbnailResize from '../utils/thronThumbnailResize';
import remToPixels from '../utils/remToPixels';

function guessParentType(theme) {
  if (theme.parentType !== undefined) {
    return theme.parentType;
  }

  return theme.collectionId !== undefined
    ? 'collections'
    : 'categories';
}

function generateLink(theme) {
  return guessParentType(theme) === 'collections'
    ? `/seasonal/${theme.collectionId}/themes/${theme.id}`
    : `/timeless/${theme.categoryId}/themes/${theme.id}`
}

function getParentName(theme) {
  return guessParentType(theme) === 'collections'
    ? theme.collectionName
    : theme.categoryName;
}

export default ({ theme, ...props }) => (
  <LinkedContainer {...props} related="true" to={generateLink(theme)} onClick={() => window.scrollTo(0, 0)}>
    <Container
      cover={thronThumbnailResize(theme.cover, { width: remToPixels(12.75) })}
      related="true"
      confidential={theme.confidential}>
      <ParentName related="true">{getParentName(theme)}</ParentName>
      <ThemeCardThemeStatus light small status={theme.status} style={{ marginBottom: '1rem', }}/>
      <ThemeName related="true">{theme.name}</ThemeName>
    </Container>
  </LinkedContainer>
);
